import React from 'react';

import * as styles from './ContentTabsLayout.css';

type TProps = {
  tabs: React.ReactNode;
  rating: React.ReactNode;
  items: React.ReactNode;
  tabLink: React.ReactNode;
};

export const ContentTabsLayout: React.FC<TProps> = ({ tabs, rating, items, tabLink }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']} data-name="ContentTabsHeader">
        {tabs}
        {rating}
      </div>
      <div>{items}</div>
      <div>{tabLink}</div>
    </div>
  );
};
